module.exports = __webpack_public_path__ + "media/images/logo/nictiz_i-ab2d227c5d589e3b9ed633e8bfcade82.png";